var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-content"},[_c('HeaderBox'),_c('div',{staticClass:"report-content"},[_c('div',{staticClass:"report-area"},[_c('p',{staticClass:"report-title"},[_vm._v("你的毕业去向决策平衡单")]),_c('img',{staticClass:"report-img score-img",attrs:{"src":_vm.balanceImage}})])]),_c('FootBox',{attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }